/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { InfoBox } from "./Infobox";
import { StyledText } from "../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { colors } from "./colors";

const placeHolderStyle = css`
  padding: 24px;
  margin-bottom: 8px;
`;

const placeHolderBodyStyle = css`
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: 16px;
`;

type Props = {
  children: React.ReactNode;
};

export const Placeholder = ({ children }: Props) => {
  return (
    <InfoBox backgroundColor={colors.ctaInactive} css={placeHolderStyle}>
      <div css={placeHolderBodyStyle}>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          <FontAwesomeIcon icon={solid("info-circle")} />
        </StyledText>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {children}
        </StyledText>
      </div>
    </InfoBox>
  );
};
